export const TruncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) return text;
    let truncated = text.slice(0, maxLength);
    let lastSpace = truncated.lastIndexOf(" ");
    if (lastSpace > 0) {
      truncated = truncated.slice(0, lastSpace);
    }
  
    return truncated + "...";
  };

  export const formatTextMin = (text:string) => text.toLowerCase().replace(/\s+/g, '');